import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-advanced-search',
  templateUrl: './table-advanced-search.component.html',
  styleUrls: ['./table-advanced-search.component.sass']
})
export class TableAdvancedSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
